import React, { Component } from 'react';
import './ArchiveHero.scss';

// expected props
// heroImage: object;
// headline: string;

export default function ArchiveHero({ 
  heroImage = {}, 
  headline = '', 
  textColor = '', 
  highlightColor = '' 
}) {
  // Safe style object construction
  const backgroundStyle = {};
  if (heroImage && heroImage.background && heroImage.background.dataOriginal) {
    backgroundStyle.backgroundImage = `url('${heroImage.background.dataOriginal}')`;
  }
  
  if (heroImage && heroImage.focus && heroImage.focus.x != null && heroImage.focus.y != null) {
    backgroundStyle.backgroundPosition = `${heroImage.focus.x * 100}% ${heroImage.focus.y * 100}%`;
  }

  return (
    <div className="archive-hero ctnr">
      {heroImage && heroImage.background && Object.keys(backgroundStyle).length > 0 && (
        <div
          className="archive-hero__background"
          style={backgroundStyle}
        />
      )}
      <div
        className={`archive-hero__text headline--alt headline--alt-lg headline--highlight headline--highlight-${highlightColor} ${textColor}`}
      >
        {headline}
      </div>
    </div>
  );
}
